import script from "./customer-edit-expenses.vue?vue&type=script&setup=true&lang=js"
export * from "./customer-edit-expenses.vue?vue&type=script&setup=true&lang=js"

import "./customer-edit-expenses.vue?vue&type=style&index=0&id=bdf8a70a&lang=css"

const __exports__ = script;

export default __exports__